import { unFormatCurrency, unFormatPercentage } from '@/common/utils/unFormatters'
import { z } from 'zod'

export const updateContractFeeDetailsSchema = z
  .object({
    contract: z.object({
      contract_fees_attributes: z.array(
        z.object({
          fee_id: z.string().optional(),
          fee_template_id: z.string(),
          display_name: z.string(),
          value: z.string(),
          calculate_as: z.string(),
          main_fee: z.boolean().optional(),
        }),
      ),
    }),
  })
  .superRefine((data, ctx) => {
    data.contract.contract_fees_attributes.map((fee, index) => {
      if (!fee.value) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Campo obrigatório.',
          path: ['contract', 'contract_fees_attributes', index, 'value'],
        })
      }

      const unFormatFunction = fee.calculate_as === 'percentage' ? unFormatPercentage : unFormatCurrency
      const value = `${unFormatFunction(fee.value)}`

      if (isNaN(Number(value))) {
        return ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Valor inválido.',
          path: ['contract', 'contract_fees_attributes', index, 'value'],
        })
      }
    })
  })

export type UpdateContractFeeDetailsSchema = z.infer<typeof updateContractFeeDetailsSchema>
